export default {"src":"/_next/static/media/therapist-auth-background.c10d0563.svg","height":900,"width":1440};